import AddGuarantorModal from './add-guarantor-modal';

export default AddGuarantorModal;
